var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewTopicPositive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 667.47 667.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #D7F0D6;\n      }\n\n      .cls-2 {\n        fill: #005921;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 333.74,
    cy: 333.74,
    r: 333.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 209.51,
    cy: 255.45,
    r: 40.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 457.97,
    cy: 255.45,
    r: 40.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.14,407.11s195.6,144.24,399.61,0c0,0-29.05,116.64-204.01,116.64s-195.6-116.64-195.6-116.64Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewTopicPositive);
export default __webpack_public_path__ + "static/media/review-topic-positive.8024a893c110cd7ab70bd099fb154413.svg";
export { ForwardRef as ReactComponent };